import AdminCertificate from "./adminCertificate"
export default AdminCertificate;